import { GetStaticPropsContext } from 'next';
import React from 'react';
import ImageHeader from '../../components/common/ImageHeader';
import NewsItem from '../../components/news/NewsItem';
import { getClient } from '../../contentful/contentfulClient';

export async function getStaticProps(context: GetStaticPropsContext) {
  const MINUTES = 60;
  const revalidate = 60 * MINUTES;
  const client = getClient(context.preview);

  const entries = await client.getEntries({
    content_type: 'news',
    order: '-fields.date',
  });

  const news = entries.items;

  return {
    props: {
      news,
    },
    revalidate, // In seconds
  };
}

const NewsPage = ({ news }) => (
  <section className="news">
    <ImageHeader image="consumer-header" title="Press Releases" />
    <section className="container space" style={{ paddingBottom: 20 }}>
      {news.map((news, i) => (
        <NewsItem key={i} {...news.fields} />
      ))}
    </section>
  </section>
);

export default NewsPage;
